import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import type { VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { variantesBotao } from './button-variants';

export interface BotaoProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof variantesBotao> {
  /** Renderiza o filho no lugar do <button> — útil para links de navegação. */
  asChild?: boolean;
}

export function Botao({
  className,
  variante,
  tamanho,
  asChild = false,
  type = 'button',
  ...props
}: BotaoProps) {
  const Componente = asChild ? Slot : 'button';

  return (
    <Componente
      // `type` padrão explícito: sem ele, um botão dentro de <form> submete
      // o formulário sem querer.
      {...(asChild ? {} : { type })}
      className={cn(variantesBotao({ variante, tamanho }), className)}
      {...props}
    />
  );
}
